import React, { useState, useEffect } from 'react'

import { Button, Form, Row, Typography, notification, Input, Col } from 'antd'
import { Formik } from 'formik'

import CustomInput from '../../../components/CustomInput/customInput'
import CustomSelect from '../../../components/CustomSelect/customSelect'
import { validRule, RULES } from '../../../constants/Entitlements'
import injectValidationMethods from '../../../util/checkValidation'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import { validationSchema } from '../../customer/customerValidations'

const { TextArea } = Input

const CreateAlternative = function ({ onCancel, alternativeId, history, updateAlternativeList }) {
  const [formLayout] = useState('vertical')

  const compState = {
    formValues: {},
    isReadOnly: [],
    current: 0,
    documentTypes: []
  }

  const [state, setState] = useState(compState)

  const [documentTypes, setDocumentTypes] = useState([])
  // Form configuration

  const form = {
    initialValues: state.formValues,

    onSubmit: async (values) => {
      const partnerDocumentDto = {
        partnerName: values.partnerName,
        documentNumber: values.documentNumber,
        phoneNumber: values.phoneNumber,
        justificationType: values.justificationType,
        approvalStatus: values.approvalStatus || 'Aguardando aprovação',
        obs: values.obs,
        original: values.original || false,
        emailAddress: values.emailAddress,
        linkedPartner: values.linkedPartner || null,
        expirationDate: values.expirationDate || new Date().toISOString().split('T')[0],
        documentTypeId: values.documentTypeId,
        active: values.active
      }

      if (alternativeId > 0) {
        await updatePartnerDocuments(alternativeId, partnerDocumentDto).then(() => onCancel())
      } else {
        const newAlternative = await cretePartnerDocument(partnerDocumentDto)
        updateAlternativeList(newAlternative)
        onCancel()
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.CUSTOMER_CONTACT) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
    listDocumentTypes()
    if (alternativeId) {
      retrieveCustomerAlternativeDocuments(alternativeId)
      checkIsReadOnly()
    } else {
      setState({ ...state, formValues: {} })
    }
    return () => {
      setState({ ...state, isReadOnly: false })
    }
  }, [])

  async function listDocumentTypes() {
    const types = await request(api.listDocumentTypes(), true)
    const formattedData = []
    types.map((item) => {
      return formattedData.push({
        value: item.id,
        description: item.name,
        mask: item.mask
      })
    })
    setDocumentTypes(formattedData)
  }

  async function retrieveCustomerAlternativeDocuments(alternativeId) {
    try {
      const response = await request(api.retrieveCustomerAlternativeDocuments(alternativeId))
      setState({ ...state, formValues: response })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function cretePartnerDocument(payload) {
    try {
      const response = await request(api.createCustomerAlternativeDocuments(payload))
      notification.success({
        description: getMessage('alternateSucessCreate'),
        message: getMessage('sweetAlerts.success')
      })
      setState({ ...state, formValues: {} })
      return response
    } catch (error) {
      onCancel()
    }
  }

  async function updatePartnerDocuments(id, payload) {
    try {
      await request(api.updateCustomerAlternativeDocuments(id, payload))
      notification.success({
        description: getMessage('successUpdatePartnerDocuments'),
        message: getMessage('sweetAlerts.success')
      })
    } catch (error) {
      onCancel()
    }
  }

  // Custom service component
  function checkIsReadOnly() {
    const searchParams = new URLSearchParams(window.location.search)
    const { readOnly } = Object.fromEntries(searchParams.entries())
    if (readOnly) {
      setState({ ...state, isReadOnly: true })
    } else {
      setState({ ...state, isReadOnly: false })
    }
  }

  function getDocumentMask(documentId) {
    const documentType = documentTypes.find((item) => item.value === documentId)
    return documentType ? documentType.mask : null
  }

  return (
    <div>
      <Formik
        enableReinitialize
        validationSchema={validationSchema}
        initialValues={state.formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) => {
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          injectValidationMethods(values)

          const setFieldValueWithState = (field, value) => {
            const newFormValues = {
              ...state.formValues,
              [field]: value
            }
            setState({ ...state, formValues: newFormValues })
            return setFieldValue(field, value)
          }

          const hasAccess = validRule(RULES.CUSTOMER_CONTACT)

          return (
            <Form className="contacts-form" layout={formLayout} onSubmit={handleSubmit}>
              <>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: '2%' }}>
                  <div style={{ width: '50%' }}>
                    <Row type="flex" justify="start">
                      <CustomInput
                        field="partnerName"
                        errors={errors}
                        required
                        setFieldValue={setFieldValueWithState}
                        handleBlur={handleBlur}
                        rowSpan={25}
                        value={values}
                      />
                    </Row>
                    <Row type="flex" justify="start">
                      <CustomSelect
                        showSearch
                        field="documentTypeId"
                        errors={errors}
                        required
                        setFieldValue={setFieldValueWithState}
                        rowSpan={12}
                        value={values}
                        values={documentTypes}
                        handleBlur={handleBlur}
                        label={`${getMessage('documentType')}`}
                      />
                      <CustomInput
                        field="documentNumber"
                        errors={errors}
                        setFieldValue={setFieldValueWithState}
                        rowSpan={12}
                        required
                        value={values}
                        handleBlur={handleBlur}
                        mask={getDocumentMask(values.documentTypeId)}
                        label={`${getMessage('documentNumber')}`}
                        disabled={!values.documentTypeId}
                      />
                      <CustomInput
                        field="phoneNumber"
                        errors={errors}
                        setFieldValue={setFieldValueWithState}
                        handleBlur={handleBlur}
                        rowSpan={12}
                        value={values}
                      />
                      <CustomInput
                        field="emailAddress"
                        errors={errors}
                        setFieldValue={setFieldValueWithState}
                        handleBlur={handleBlur}
                        rowSpan={12}
                        value={values}
                      />
                    </Row>
                    <Row type="flex" justify="start">
                      <CustomInput
                        field="justificationType"
                        setFieldValue={setFieldValueWithState}
                        errors={errors}
                        handleBlur={handleBlur}
                        rowSpan={12}
                        value={values}
                      />
                      <Col span={12}>
                        <span>{getMessage('approvalStatus')}</span>
                        <Input style={{ marginTop: 8 }} value={values.approvalStatus} disabled />
                      </Col>
                    </Row>
                  </div>
                  <div className="line-vertical"></div>
                  <div style={{ width: '46%', marginLeft: 17 }}>
                    <Typography level={3} style={{ marginBottom: 7 }}>
                      Observações
                    </Typography>
                    <TextArea
                      rows={13}
                      value={values.obs}
                      onChange={(event) => setFieldValueWithState('obs', event.target.value)}
                    />
                  </div>
                </div>
                <div
                  style={{
                    flex: 1,
                    justifyContent: 'flex-end',
                    flexDirection: 'row',
                    display: 'flex',
                    marginTop: '2%'
                  }}
                >
                  {hasAccess && (
                    <>
                      <Button
                        type="primary"
                        className="button-action"
                        onClick={() => {
                          submitForm()
                        }}
                      >
                        {alternativeId ? getMessage('update') : getMessage('register')}
                      </Button>
                      <Button className="button-action" onClick={() => onCancel()}>
                        {getMessage('cancel')}
                      </Button>
                    </>
                  )}
                </div>
              </>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default CreateAlternative
